import { ChangeDetectionStrategy, Component, effect, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from '../../../services/message.service';
import { AuthService } from '../auth.service';
import { ILoginUser } from '../new_user.interface';

@Component({
    selector: 'app-jcall-login',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
    ],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
    registration = false;

    registrationForm;

    constructor(
        private dialogRef: MatDialogRef<LoginComponent>,
        private fb: FormBuilder,
        private messageService: MessageService,
        @Inject(MAT_DIALOG_DATA) private data: { authService: AuthService },
    ) {
        this.registrationForm = this.fb.group({
            login: [null, [Validators.required]],
            password: [null, [Validators.required]],
            confirmedPassword: [null, [Validators.required]],
        });

        effect(() => {
            if (this.data.authService.loggedIn()) {
                this.close();
            }
        });
    }

    close(): void {
        this.dialogRef.close();
    }

    registerNewUser(): void {
        if (
            this.registrationForm.value.confirmedPassword !== this.registrationForm.value.password
        ) {
            this.messageService.warningMessage('Пароли не совпадают!');
        }

        this.data.authService.registration(this.registrationForm.value as ILoginUser);
        this.registration = false;
    }

    logIn(): void {
        this.data.authService.logIn(this.registrationForm.value as ILoginUser);
    }
}
